/* eslint-disable no-shadow */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-vars */
/* eslint-disable func-names */
import EDC from './globals';

EDC.Preloaders.Music = function (scene, list) {
  scene.load.setPath('https://s3.amazonaws.com/images.growmindgrow/phaser-assets/audio/music/');
  let bgIndexStr = '';
  const rndIndex = 0;
  if (list) {
    if (list.length === 1) {
      bgIndexStr = list[0];
      scene.load.audio(`music-${bgIndexStr}`, `${bgIndexStr}.mp3`);
    } else {
      for (let i = 0; i < list.length; i++) {
        scene.load.audio(`music-${list[i]}`, `${list[i]}.mp3`);
      }
    }
  } else {
    const musicList = [58];
    const rndIndex = Math.floor(Math.random() * musicList.length);
    const selectedmusic = musicList[rndIndex];
    bgIndexStr = selectedmusic;
    if (selectedmusic < 10) {
      bgIndexStr = `00${selectedmusic}`;
    } else if (selectedmusic >= 10 && selectedmusic < 100) {
      bgIndexStr = `0${selectedmusic}`;
    }
    scene.load.audio('music', `${bgIndexStr}.mp3`);
  }

  scene.load.setPath();
};

export default EDC.Preloaders.Music;
